import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';

import {
    DEFAULT_STYLING,
    INDETERMINATE_DEFAULT_STYLING,
    INDETERMINATE_SMALL_SIZE_STYLING,
    SMALL_SIZE_STYLING,
} from './constants.ts';

const pickColor = <T>(options: {
    disabled?: boolean;
    hasError?: boolean;
    isReadOnly?: boolean;
    values: { disabled: T; hasError: T; isReadOnly: T; default: T };
}): T => {
    const { disabled, hasError, isReadOnly, values } = options;

    if (disabled) return values.disabled;
    if (hasError) return values.hasError;
    if (isReadOnly) return values.isReadOnly;

    return values.default;
};

export const getCheckboxAfterStyle = (isSmallSize = false, indeterminate = false) => {
    if (indeterminate) {
        return isSmallSize ? INDETERMINATE_SMALL_SIZE_STYLING : INDETERMINATE_DEFAULT_STYLING;
    }

    return isSmallSize ? SMALL_SIZE_STYLING : DEFAULT_STYLING;
};

export const getCheckboxHoverBackground = ({
    checked = false,
    hasError = false,
    indeterminate = false,
    isReadOnly = false,
}: {
    checked?: boolean;
    hasError?: boolean;
    indeterminate?: boolean;
    isReadOnly?: boolean;
}) => {
    if (hasError) return SC.error;
    if (indeterminate) return SC.actionHover;
    if (isReadOnly) return SC.white;

    return checked ? SC.actionHover : SC.page;
};

export const getCheckboxBackground = (args: { disabled?: boolean; hasError?: boolean; isReadOnly?: boolean }) =>
    pickColor({
        ...args,
        values: { disabled: SC.disabled, hasError: SC.error, isReadOnly: SC.white, default: SC.action },
    });

export const getIndeterminateBorderColor = (args: { disabled?: boolean; hasError?: boolean; isReadOnly?: boolean }) =>
    pickColor({
        ...args,
        values: { disabled: BC.disabled, hasError: BC.error, isReadOnly: BC.default, default: BC.action },
    });

export const getIndeterminateTickColor = (args: { disabled?: boolean; hasError?: boolean; isReadOnly?: boolean }) =>
    pickColor({
        ...args,
        values: { disabled: BC.disabled, hasError: BC.error, isReadOnly: TC.body, default: BC.white },
    });

export const getHoveredBorderColor = (args: { hasError?: boolean; isReadOnly?: boolean }) =>
    pickColor({
        ...args,
        values: { disabled: BC.default, hasError: BC.error, isReadOnly: BC.default, default: BC.action },
    });

export const getCheckboxTickBorderColor = (args: { hasError?: boolean; isReadOnly?: boolean }) =>
    pickColor({ ...args, values: { disabled: BC.white, hasError: BC.error, isReadOnly: TC.body, default: BC.white } });
